import React, { useState, createContext } from "react";

const defaultLayerVisibility = {
  address: false,
  conduit: false,
  fibercable: false,
  lcpBoundaries: true,
  parcels: false,
  photoPoints: true,
  poles: true,
  spliceClosures: true,
  strand: false,
  structures: true,
};

const retrieveStoredBasemap = () => {
  const storedBasemap = localStorage.getItem("esriBasemap");
  return storedBasemap ? storedBasemap : "topo-vector";
};

const MapContext = createContext({
  layerVisibility: defaultLayerVisibility,
  basemap: "topo-vector",
});

const retriveStoredLayerVisibility = () => {
  const storedLayerVisibility = JSON.parse(
    localStorage.getItem("layerVisibility")
  );
  return {
    layerVisibility: storedLayerVisibility
      ? storedLayerVisibility
      : defaultLayerVisibility,
  };
};

export const MapContextProvider = (props) => {
  const storedLayerData = retriveStoredLayerVisibility();
  const storedBasemap = retrieveStoredBasemap();
  const [layerVisibility, setLayerVisibility] = useState(storedLayerData);
  const [basemap, setBasemap] = useState(storedBasemap);

  const saveLayerVisibility = (layerObj) => {
    setLayerVisibility(layerObj);
    localStorage.setItem("layerVisibility", JSON.stringify(layerObj));
  };

  const saveBasemap = (newBasemap) => {
    setBasemap(newBasemap);
    localStorage.setItem("esriBasemap", newBasemap);
  };

  const contextValue = {
    layerVisibility: layerVisibility.layerVisibility,
    basemap: basemap,
    saveLayerVisibility: saveLayerVisibility,
    saveBasemap: saveBasemap,
    retriveStoredLayerVisibility: retriveStoredLayerVisibility,
  };

  return (
    <MapContext.Provider value={contextValue}>
      {props.children}
    </MapContext.Provider>
  );
};

export default MapContext;
